import ajax from "@/lib/ajax";

/**
 * 查询患者体格检查和系统问诊
 * @param recordId 腹透记录编号
 */
export async function GetPdMedicalRecord(recordId: number) {
    let res = await ajax.get(`/api/services/app/PDExamination/GetPdMedicalRecord?recordId=` + recordId);
    return res.data.result;
}

// 保存患者体格检查和系统问诊
export async function SavePdMedicalRecord(payload: any) {
    let res = await ajax.post(`/api/services/app/PDExamination/SavePdMedicalRecord`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdOutPatient/pdMedicalRecord/index.ts